var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trust-payment"},[_c('form',{attrs:{"id":"st-form","action":"https://alleatapp.com/base/trustPay/getTrustPay","method":"POST"}},[_c('div',{attrs:{"id":"st-card-number"}}),_c('div',{attrs:{"id":"st-expiration-date"}}),_c('div',{attrs:{"id":"st-security-code"}}),_c('button',{attrs:{"type":"submit"}},[_vm._v("Pay securely")])])])
}]

export { render, staticRenderFns }